import { gql } from "@apollo/client";export default gql`mutation UpdateSetCollection($id: Int = 10, $order: Int = 10) {
    update_set_collection_by_pk(
        pk_columns: { id: $id }
        _set: { order: $order }
    ) {
        id
    }
}
`;
